import React from 'react'
import ForwardIcon from '@material-ui/icons/Forward';
import Tr from 'translations/Translations';
import PropTypes from "prop-types";
import WorkableIconButton from "./WorkableIconButton";

function WorkableIconForwardButton(
    {
        tooltip = Tr('enter'),
        ...props
    }) {
    return <WorkableIconButton
        tooltip={tooltip}
        Icon={ForwardIcon}
        {...props}
    />
}

WorkableIconForwardButton.propTypes = {
    working: PropTypes.bool,
    disabled: PropTypes.bool,
    tooltip: PropTypes.string,
    hideTooltip: PropTypes.bool,
    color: PropTypes.string,
    onClick: PropTypes.func
}

export default WorkableIconForwardButton;